import React from 'react';
import classNames from 'classnames';
import { mergeStyles } from 'wix-rich-content-common';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z = ".QWuYm,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}[dir] ._2iIFm{border:none}.tbked{color:var(--ricos-settings-text-color,#333);font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial);font-size:14px;line-height:1.5}[dir] .tbked{margin-bottom:14px}";
var styles = {"fontElementMap":"QWuYm","section":"_2iIFm","sectionHeader":"tbked"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class SettingsSection extends React.Component {
  constructor(props) {
    super(props);
    this.styles = mergeStyles({ styles, theme: props.theme });
  }
  render() {
    const { styles: styles2 } = this;
    const { children, ariaProps, className, headerText } = this.props;
    return /* @__PURE__ */ React.createElement("div", __spreadValues({ className: classNames(styles2.section, className) }, ariaProps), headerText && /* @__PURE__ */ React.createElement("div", { className: styles2.sectionHeader }, " ", headerText, " "), children);
  }
}

export { SettingsSection as default };
//# sourceMappingURL=SettingsSection.js.map
